import {DceComponent} from "dce-engine";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import Dce from "dce-engine/lib/decorators/Dce";

interface SelectChangeTogglerProps {
    selectName: string
}

@Dce("SelectChangeToggler")
export default class SelectChangeToggler extends DceComponent<SelectChangeTogglerProps> {

    private jqElem: JQuery<HTMLElement>;
    private jqSelect: JQuery<HTMLElement>;

    constructor(elem: DceHTMLElement, props: SelectChangeTogglerProps) {
        super(elem, props);
        this.jqElem = $(elem);

        this.jqSelect = this.jqElem.find('select[name="' + this.props.selectName + '"]');

        this.jqSelect.on('change', (e) => {
            this.valueChanged();
        });

        this.valueChanged();

    }

    private valueChanged(){

        let value: string = this.jqSelect.val() as string;

        this.jqElem.find('*[data-select-val]').each((i, e) => {
            let $block = $(e);

            let x = $block.data('select-val');

            console.log(x);

            let values = $block.attr('data-select-val').split(',');

            if(values.indexOf(value) > -1){
                $block.show();
            }else{
                $block.hide();
            }
        })

    }



}